// extracted by mini-css-extract-plugin
module.exports = {"appointmentRequestTag":"appointment-request-tag_appointmentRequestTag__SGepX"};